import React from 'react'
import { Outlet } from 'react-router-dom'

import { AuthProvider } from 'pkg/authentication'

import Main from 'components/Main'
import UserPolicyProvider from 'components/UserPolicyProvider'
import UserTagsProvider from 'components/UserTagsProvider'

import DashboardIntegrationProvider from './DashboardIntegrationProvider'
import UserTrackerLogin from './UserTrackerLogin'

import handleAuthComplete from './lib/handleAuthComplete'


export default function PagesRequiringUserRecord() {
  return (
    <AuthProvider
      handleAuthComplete={ handleAuthComplete }
    >
      <UserPolicyProvider>
        <DashboardIntegrationProvider>
          <UserTagsProvider>
            <UserTrackerLogin>
              <Main>
                <Outlet />
              </Main>
            </UserTrackerLogin>
          </UserTagsProvider>
        </DashboardIntegrationProvider>
      </UserPolicyProvider>
    </AuthProvider>
  )
}
